import _ from 'lodash'
import { reducerWithInitialState } from 'typescript-fsa-reducers'
import { House } from '../../types'
import * as actions from './actions'

export type State = { [id: number]: House }

export const initialState: State = {}

export default reducerWithInitialState(initialState).case(
	actions.registerHouses,
	(state, objects) => {
		return { ...state, ..._.keyBy(objects, 'id') }
	},
)
